// Composant de carte mobile réutilisable avec la palette de couleurs de l'application
import React from "react";

interface MobileCardProps {
  children: React.ReactNode;
  className?: string;
  padding?: "sm" | "md" | "lg";
  shadow?: "sm" | "md" | "lg";
  rounded?: "sm" | "md" | "lg" | "xl";
}

const MobileCard: React.FC<MobileCardProps> = ({
  children,
  className = "",
  padding = "md",
  shadow = "sm",
  rounded = "lg",
}) => {
  const paddingClasses = {
    sm: "p-3",
    md: "p-4",
    lg: "p-6",
  };

  const shadowClasses = {
    sm: "shadow-sm",
    md: "shadow-md",
    lg: "shadow-lg",
  };

  const roundedClasses = {
    sm: "rounded-sm",
    md: "rounded-md",
    lg: "rounded-lg",
    xl: "rounded-xl",
  };

  return (
    <div
      className={`
      bg-white 
      ${paddingClasses[padding]} 
      ${shadowClasses[shadow]} 
      ${roundedClasses[rounded]}
      border border-stroke
      ${className}
    `}
    >
      {children}
    </div>
  );
};

export default MobileCard;
